import { IDowntimeManagementConfigResponse, IFormattedDownTimeMeterPayload } from './type';

export const dehydrateFormData = (data: IFormattedDownTimeMeterPayload): IDowntimeManagementConfigResponse => {
	const downTimeConfig: IDowntimeManagementConfigResponse = {
		defaultDowntimeMeter: {},
		bank: {},
		instrument: {},
		handle: {}
	} as IDowntimeManagementConfigResponse;
	downTimeConfig.defaultDowntimeMeter.low = data.defaultDowntimeMeter['defaultDowntimeMeter-low'];
	downTimeConfig.defaultDowntimeMeter.poor = data.defaultDowntimeMeter['defaultDowntimeMeter-poor'];
	downTimeConfig.defaultDowntimeMeter.critical = data.defaultDowntimeMeter['defaultDowntimeMeter-critical'];
	downTimeConfig.bank.low = data.bank['bank-low'];
	downTimeConfig.bank.poor = data.bank['bank-poor'];
	downTimeConfig.bank.critical = data.bank['bank-critical'];
	downTimeConfig.instrument.low = data.instrument['instrument-low'];
	downTimeConfig.instrument.poor = data.instrument['instrument-poor'];
	downTimeConfig.instrument.critical = data.instrument['instrument-critical'];
	downTimeConfig.handle.low = data.handle['handle-low'];
	downTimeConfig.handle.poor = data.handle['handle-poor'];
	downTimeConfig.handle.critical = data.handle['handle-critical'];
	return downTimeConfig;
};
